/**
 * GuestLimitModal
 *
 * Shown when a Personal-plan project answers a 409 GUEST_LIMIT_REACHED to
 * `sendInvite` or `addMember` (FLOW-888) — the project already has as many
 * guest collaborators as the plan includes. Modelled on
 * `components/quota/QuotaPaywallModal.tsx`.
 */
import { Component } from "solid-js";
import { Modal, Button } from "../ui";

export interface GuestLimitModalProps {
  open: boolean;
  onClose: () => void;
  onViewPlans: () => void;
}

export const GuestLimitModal: Component<GuestLimitModalProps> = (props) => {
  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      title="Upgrade to Pro to add more collaborators"
      size="sm"
    >
      <div class="flex flex-col gap-4">
        <p class="text-sm text-ink-2">
          The Personal plan includes 2 free guest collaborators per project.
          Upgrade to Pro ($50/seat/mo) to add more.
        </p>
        <div class="flex justify-end gap-2">
          <Button variant="secondary" onClick={props.onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={props.onViewPlans}>
            View plans
          </Button>
        </div>
      </div>
    </Modal>
  );
};
